import './layout.scss';
import Vue from 'vue';
import macc from '../../modules/MACC/macc';
import meda from '../../modules/MEDA/meda';
import mjbl from '../../modules/MJBL/mjbl.vue';
import mstb from '../../modules/MSTB/mstb';
import meok from '../../modules/MEOK/meok';
import mint from '../../modules/MINT/mint.vue';
import mint2021 from '../../modules/MINT2021/mint2021.vue';
/* components for inherintance */
import mevp from '../../modules/MEVP/mevp';
import mhap from '../../modules/MHAP/mhap.vue';
import mksz from '../../modules/MKSZ/mksz';
import mtab from '../../modules/MTAB/mtab';
import mrbt from '../../modules/MRBT/mrbt';
import mdtb from '../../modules/MDTB/mdtb';
import mtbl from '../../modules/MTBL/mtbl';
import mubt from '../../modules/MUBT/mubt';
import moav from '../../modules/MOAV/moav';
import mife from '../../modules/MIFE/mife';
import masd from '../../modules/MASD/masd.vue';
import mfsh from '../../modules/MFSH/mfsh.vue';
/* components for inherintance */
import layoutBase from '../layout-base';
import videoPlayer from '../../common/components/video-player/video-player.vue';

Vue.component('macc', macc);
Vue.component('mdtb', mdtb);
Vue.component('meok', meok);
Vue.component('mevp', mevp);
Vue.component('mint', mint);
Vue.component('mint2021', mint2021);
Vue.component('mjbl', mjbl);
Vue.component('mrbt', mrbt);
Vue.component('mstb', mstb);
Vue.component('mtbl', mtbl);
Vue.component('mubt', mubt);
Vue.component('mtab', mtab);
Vue.component('meda', meda);
Vue.component('mjbl', mjbl);
Vue.component('meok', meok);
Vue.component('mint', mint);
Vue.component('mhap', mhap);
Vue.component('mksz', mksz);
Vue.component('mrbt', mrbt);
Vue.component('moav', moav);
Vue.component('mife', mife);
Vue.component('mfsh', mfsh);
Vue.component('masd', masd);
Vue.component('video-player', videoPlayer);
/* eslint-disable no-new*/
new Vue({
	el: '[data-layout-id=PPTER-app]',
	extends: layoutBase
});
/* eslint-enable*/
